import companyInput from './saveInputs/companyInput';

export default (company) => `
    deleteOrg (org: {
        ${companyInput(company)}
    })
`;
